// extracted by mini-css-extract-plugin
export default {"screen-titles--title":"Input_screen-titles--title__XkKNP","input":"Input_input__k5Ctk","error":"Input_error__1wKFK"};